import React, { useState, useRef } from 'react';
import './Contact.css';
import { FaEnvelope, FaPhone, FaWhatsapp, FaMapMarkerAlt } from 'react-icons/fa';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);


  const EMAILJS_CONFIG = {
    SERVICE_ID: 'Infosfera Service',      
    TEMPLATE_ID: 'template_3eag5pm',  
    PUBLIC_KEY: '42O4uwaxHTTMItZTj'      
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      
      const formData = new FormData(formRef.current);
      formData.append('current_date', new Date().toLocaleString('pt-PT'));

     
      const result = await emailjs.sendForm(
        EMAILJS_CONFIG.SERVICE_ID,
        EMAILJS_CONFIG.TEMPLATE_ID,
        formRef.current,
        EMAILJS_CONFIG.PUBLIC_KEY
      );

      if (result.text === 'OK') {
        setSubmitStatus('success');
        formRef.current.reset();
        
        
        setTimeout(() => setSubmitStatus(null), 5000);
      } else {
        setSubmitStatus('error');
        setTimeout(() => setSubmitStatus(null), 5000);
      }
    } catch (error) {
      console.error('Erro detalhado:', error);
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus(null), 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <section className="page-header">
        <h1>Contacto</h1>
        <p>Entre em contacto conosco para mais informações</p>
      </section>
      
      <div className="container">
        <div className="contact-container">
          <div className="contact-cards">
            <div className="contact-form">
              <h2>Envie-nos uma mensagem</h2>
              
              {/* Mensagem de Sucesso */}
              {submitStatus === 'success' && (
                <div className="success-message">
                  <strong>✅ Mensagem enviada com sucesso!</strong>
                  <p>Entraremos em contacto em breve. Obrigado pelo seu contato!</p>
                </div>
              )}
              
              {/* Mensagem de Erro */}
              {submitStatus === 'error' && (
                <div className="error-message">
                  <strong>❌ Erro ao enviar mensagem.</strong>
                  <p>Por favor, tente novamente ou contacte-nos por telefone.</p>
                </div>
              )}
              
           
              <form ref={formRef} onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Nome:</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    disabled={isSubmitting}
                    placeholder="Seu nome completo"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">E-mail:</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    disabled={isSubmitting}
                    placeholder="seu@email.com"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="subject">Assunto:</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    required
                    disabled={isSubmitting}
                    placeholder="Assunto da mensagem"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Mensagem:</label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    disabled={isSubmitting}
                    rows="5"
                    placeholder="Digite sua mensagem aqui..."
                  ></textarea>
                </div>
                
                <button 
                  type="submit" 
                  className="btn-primary" 
                  disabled={isSubmitting}
                >
                  {isSubmitting ? '📧 Enviando...' : '📨 Enviar Mensagem'}
                </button>
              </form>
            </div>
            
            {/* Informações de Contato */}
            <div className="contact-info">
              <h2>Informações de Contato</h2>
              
              <div className="contact-method">
                <FaEnvelope className="contact-icon" />
                <div>
                  <h3>E-mail</h3>
                  <p>info@infosfera.co.mz</p>
                </div>
              </div>
              
              <div className="contact-method">
                <FaMapMarkerAlt className="contact-icon" />
                <div>
                  <h3>Endereço</h3>
                  <p>Maputo, Bairro da Polana Cemeto Av. Maguiguane</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Mapa */}
          <div className="map-section">
            <h2>Onde nos encontrar</h2>
            <div className="map-container">
              <iframe
                title="Localização da empresa"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14347.442330451795!2d32.58548488644388!3d-25.972612354065124!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1ee69b00af1b9719%3A0xceedbefa79c9a2bd!2sAvenida%20de%20Maguiguana%2C%20Maputo!5e0!3m2!1spt-PT!2smz!4v1775234213240!5m2!1spt-PT!2smz" 
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;